export const iconFontAwesomeCharityDove = (
	<i className="fa-solid fa-dove"></i>
);
